// const zeroTime = (date) => {
//   date.setHours(0);
//   date.setMinutes(0);
//   date.setSeconds(0);
//   date.setMilliseconds(0);
//   return date;
// };

//gets the monday of the week the date is in
const getMonday = (date) => {
  date.setDate(date.getDate() - 1);
  date.setDate(date.getDate() - date.getDay() + 1);
  return date;
};

export const formatDate = (date) => ({
  yyyy: String(date.getFullYear()),
  MM: String(date.getMonth() + 1).padStart(2, "0"),
  dd: String(date.getDate()).padStart(2, "0"),
  HH: String(date.getHours()).padStart(2, "0"),
  mm: String(date.getMinutes()).padStart(2, "0"),
  ss: String(date.getSeconds()).padStart(2, "0"),
  fff: String(date.getMilliseconds()).padStart(3, "0"),
});

const getAucklandTimezoneOffset = () => {
  const now = new Date();
  // get the timezone offset between UTC and Pacfic/Auckland time in miliseconds
  // this code has vulnerabilities due to it using system local time
  // relying on client system settings to be correct is bad...
  // but I have no other option ¯\_(ツ)_/¯

  // Abuse the Intl API to get a local ISO 8601 string for a given time zone.
  let iso = getFormattedAucklandDatetime();

  // .toLocaleString has no options to include miliseconds
  // Include the milliseconds from the original timestamp
  iso += "." + now.getMilliseconds().toString().padStart(3, "0");

  // Lie to the Date object constructor that it's a UTC time.
  const lie = new Date(iso + "Z");

  // Return the difference in timestamps in miliseconds
  // Positive values are West of GMT, opposite of ISO 8601
  // this matches the output of `Date.getTimeZoneOffset`
  return -(lie - now);
};

const getFormattedAucklandDatetime = () => 
{
  const now = new Date();
  const timeOptions = {
    timeZone: "Pacific/Auckland",    
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: false,
  };
  const aucklandTime = now.toLocaleTimeString("en-NZ", timeOptions);
  const currYear = now.toLocaleString("en-NZ", { timeZone: "Pacific/Auckland", hour12: false, year: "numeric" });
  const currMonth = now.toLocaleString("en-NZ", { timeZone: "Pacific/Auckland", hour12: false, month: "2-digit" })
  const currDay = now.toLocaleString("en-NZ", { timeZone: "Pacific/Auckland", hour12: false, day: "2-digit" })
  const formattedOutput = currYear + "-" + currMonth + "-" + currDay + "T" + aucklandTime

  return formattedOutput;
}

const setNzTimeZero = (utcDate) => {
  // sets time to 00:00:00.000 in Pacific/Auckland time

  // get the offset
  const offset = getAucklandTimezoneOffset();

  // shift the time forward by the offset to make it NZ time
  const nzDate = new Date(utcDate.valueOf() - offset);

  // drop/zero the time
  const nzZeroTimeIso = nzDate.toISOString().split("T")[0];

  // parse the zerotime date
  const nzZeroTimeDate = new Date(nzZeroTimeIso);

  // shift the time back by the offset to make it UTC time
  const utcNzZeroTimeDate = new Date(nzZeroTimeDate.valueOf() + offset);

  return utcNzZeroTimeDate;
};

export const getWeekDates = (week) => {
  //week is the number of weeks ago

  // get current time in UTC
  var date = new Date()
  var utc_now = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
      date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());

  // zero the time in NZ
  const zeroTime = setNzTimeZero(utc_now);

  // get the monday of the week which the date falls in
  const monday = getMonday(zeroTime);

  // shift the monday depending on the desired week
  monday.setDate(monday.getDate() - 7 * week);

  // get the sunday
  const sunday = new Date(monday.valueOf() - 1);
  sunday.setDate(sunday.getDate() + 7);

  const start = formatDate(monday);
  const end = formatDate(sunday);

  // const timezoneOffset = new Date().getTimezoneOffset() / 60;

  // // const startIso = `${start.yyyy}-${start.MM}-${start.dd}T${start.HH}:${
  // //   start.mm
  // // }:${start.ss}.${start.fff}+${timezoneOffset * -1}`;

  // // const endIso = `${end.yyyy}-${end.MM}-${end.dd}T${end.HH}:${end.mm}:${
  // //   end.ss
  // // }.${end.fff}+${timezoneOffset * -1}`;

  return {
    start,
    end,
    startDate: monday,
    endDate: sunday,
    // startIso,
    // endIso,
  };
};

export const getDateFromWeekAndDay = (week, day) => {
  // week is the number of weeks ago
  const monday = getMonday(setNzTimeZero(new Date()));
  monday.setDate(monday.getDate() - 7 * week);
  const currentDate = new Date(monday.valueOf());
  currentDate.setDate(currentDate.getDate() + day);

  const dateString = formatDate(currentDate);

  return {
    date: currentDate,
    dateString,
    dateIsoString: `${dateString.yyyy}-${dateString.MM}-${dateString.dd}T00:00:00`,
    // dateIsoString: currentDate.toISOString(),
  };
};

export const getDayOfWeekFromDate = (dateString) => {
  const date = new Date(dateString);
  date.setDate(date.getDate() - 1);
  return date.getDay();
};

export const getWeekFromDate = (dateString) => {
  const monday = getMonday(setNzTimeZero(new Date()));
  const givenMonday = getMonday(setNzTimeZero(new Date(dateString)));
  return Math.round(
    (monday.getTime() - givenMonday.getTime()) / (86400000 * 7)
  );
};

export const getSingleDayString = (dateString) => ({
  startDayTime: dateString + 'T00:00:00.000',
  endDayTime: dateString + 'T23:59:59.999'  
})

export const downloadData = (body) => {
  const { fileName, contentType, data } = body;
  const buf = Buffer.from(data, "base64");
  const blob = new Blob([buf], { type: contentType });
  const url = URL.createObjectURL(blob);

  let element = document.createElement("a");
  element.style.display = "none";
  element.setAttribute("href", url);
  element.setAttribute("download", fileName);
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};

// login and auth functions

export const getToken = () => sessionStorage.getItem("token");
export const setToken = (token) => sessionStorage.setItem("token", token);

export const getStoredUserData = () =>
  JSON.parse(sessionStorage.getItem("userData") || "{}");
export const setStoredUserData = (userData) =>
  sessionStorage.setItem("userData", JSON.stringify(userData));

export const getDeviceId = () => localStorage.getItem("deviceId");
export const setDeviceId = (deviceId) =>
  localStorage.setItem("deviceId", deviceId);

export const getFloatingRate = (week, truckPayments) => {
  const { startDate: weekStartDate } = getWeekDates(week);
  // console.log(truckObj);
  // console.log(weekStartDate);
  let rate;
  truckPayments.some((payment) => {
    if (payment.floatingRate) {
      const paymentStartDate = new Date(payment.startDate);
      // console.log(paymentStartDate);
      if (!payment.endDate) {
        if (paymentStartDate <= weekStartDate) {
          // console.log(paymentStartDate, weekStartDate);
          // console.log(paymentStartDate <= weekStartDate);
          rate = payment.floatingRate;
          return true;
        }
      } else {
        const paymentEndDate = new Date(payment.endDate);
        if (
          paymentStartDate <= weekStartDate &&
          weekStartDate <= paymentEndDate
        ) {
          // console.log(paymentStartDate, weekStartDate, paymentEndDate);
          rate = payment.floatingRate;

          return true;
        }
      }
    }
    return false;
  });

  return rate;
};

export const displayMoney = (value) => {
  const dollars = Math.floor(value);
  const decimal = value - dollars;
  // toFixed(10) because JavaScript numbers can store base10 numbers to 10 decimal places
  const cents = (decimal * 100).toFixed(10);
  const centsRounded = Math.round(cents);
  return `${dollars}.${centsRounded}`;
};

export const getCurrentBranchesObject = (branchArray, week) => {
  const { startDate, endDate } = getWeekDates(week);

  const currentBranches = branchArray.filter((branch) => {
    const branchStartDate = new Date(branch.startDate);
    const branchEndDate = new Date(branch.endDate);

    if (!branch.endDate) {
      if (branchStartDate < endDate) {
        // if no end date and start date is before week end date
        return true;
      }
      return false;
    }
    if (branchEndDate <= startDate || endDate <= branchStartDate) {
      // if no overlap
      return false;
    }
    return true;
  });

  const branchesObject = currentBranches.reduce((acc, cur) => {
    acc[cur.id] = cur;
    return acc;
  }, {});

  return branchesObject;
};

export const getCurrentBranchesArray = (branchArray, week) => {
  const { startDate, endDate } = getWeekDates(week);

  const currentBranches = branchArray.filter((branch) => {
    const branchStartDate = new Date(branch.startDate);
    const branchEndDate = new Date(branch.endDate);

    if (!branch.endDate) {
      if (branchStartDate < endDate) {
        // if no end date and start date is before week end date
        return true;
      }
      return false;
    }
    if (branchEndDate <= startDate || endDate <= branchStartDate) {
      // if no overlap
      return false;
    }
    return true;
  });

  return currentBranches;
};
